import apiSlice from './apiSlice';

export interface DeclareResultPayload {
    market: string;
    marketType: 'NORMAL' | 'FANCY' | 'PREMIUM' | string;
    eventId: string;
    marketId: string;
    selectionId?: string;
    result?: string;
}

export const betResultApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // PENDING RESULT
        declareResult: builder.mutation<any, DeclareResultPayload>({
            query: (payload) => ({
                url: '/bet-result/declare',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['PendingMarkets'],
        }),

        // ROLLBACK RESULT
        rollbackResult: builder.mutation<any, DeclareResultPayload>({
            query: (payload) => ({
                url: '/bet-result/manual/rollback',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['RollbackMarkets'],
        }),

        // SYNC PROVIDER RESULTS MATCH-WISE
        syncMatchResults: builder.mutation<any, { gmid: string; sportsId?: number }>({
            query: ({ gmid, sportsId = 4 }) => ({
                url: `/bet-result/provider/sync/${gmid}?sportsId=${sportsId}`,
                method: 'POST',
            }),
            invalidatesTags: ['PendingMarkets', 'RollbackMarkets'],
        }),

        // SYNC ALL ACTIVE MATCHES RESULTS
        syncAllMatchesResults: builder.mutation<any, void>({
            query: () => ({
                url: '/bet-result/provider/sync-all',
                method: 'POST',
            }),
            invalidatesTags: ['PendingMarkets', 'RollbackMarkets'],
        }),

        // PREVIEW PROVIDER MATCH RESULTS
        getProviderMatchResults: builder.query<any, { gmid: string; sportsId?: number }>({
            query: ({ gmid, sportsId = 4 }) => ({
                url: `/bet-result/provider/results/${gmid}?sportsId=${sportsId}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useDeclareResultMutation,
    useRollbackResultMutation,
    useSyncMatchResultsMutation,
    useSyncAllMatchesResultsMutation,
    useGetProviderMatchResultsQuery,
    useLazyGetProviderMatchResultsQuery,
} = betResultApi;
